

import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Register from './components/Register';
import Home from './Home';
import Adicionar from './components/Adicionar';
import MeusProjetos from './MeusProjetos';
import Projeto from './components/Projeto';
import Uploader from './components/Upload';
import Menu from './components/Menu';
import Editar from './components/Editar';
import Colaborador from './components/Colaborador';
import Participante from './components/Participante';
import Main from './components/MainProject';
import CriarOrdem from './components/CriarOredem';
import CriarMensagem from './components/CriarMensagem';
import OrdensDeServico from './components/OrdensDeServico';
import Login from './components/Login';
import AdicionarColaborador from './components/AdicionarColaborador.js'
import Entrar from './components/Login';
import EnviarMensagens from './components/EnviarMensagens';
import Ordem from './components/Ordem';
import EditarProjeto from './components/EditarProjeto';
import UploadMaster from './components/UploadMaster';
import EditarPendencia from './components/EditarPendencia.js';
import Termos from './components/Termos.js';
import Sobre from './components/Sobre.js';
import Privacidade from './components/Privacidade.js';
import AdicionarDisciplina from './components/Adicionardisciplina.js';
import AdicionarColaboradores from './components/Adicionarcolaboradores.js';
import Relatorio from './components/Relatorio.js';
import Descricao from './components/Descricao.js';
import RelatorioMain from './components/RelatorioMain.js';
import PendenciaMaster from './components/PendenciaMaster.js';
import Conta from './components/Conta.js';
import TermosDeUso from './components/TermosDeUso.js';
import PoliticasDePrivacidade from './components/PoliticasDePrivacidade.js';



function App() {
  return (
    <div>
     
         <BrowserRouter>
     <Routes>
  
     <Route exact path="/" element={<Home/>}/>
     <Route exact path="/register" element={<Register/>}/>     
     <Route exact path="/adicionar" element={<Adicionar/>}/>     
     <Route exact path="/termos" element={<Termos/>}/>     
     <Route exact path="/adicionardisciplina" element={<AdicionarDisciplina/>}/> 
     <Route exact path="/adicionarcolaboradores" element={<AdicionarColaboradores/>}/> 
        

      <Route exact path="/termosdeuso" element={<TermosDeUso/>}/>     
      <Route exact path="/politicasdeprivacidade" element={<PoliticasDePrivacidade/>}/>     

     <Route exact path="/privacidade" element={<Privacidade/>}/>     
     <Route exact path="/PendenciaMaster" element={<PendenciaMaster/>}/>     
     <Route exact path="/sobre" element={<Sobre/>}/>     
     <Route exact path="/conta" element={<Conta/>}/>     
     <Route exact path="/relatoriomain" element={<RelatorioMain/>}/>     
     <Route exact path="/descricao" element={<Descricao/>}/>     
     <Route exact path="/meusprojetos" element={<MeusProjetos/>}/>     
     <Route exact path="/projeto" element={<Projeto/>}/>     
     <Route exact path="/adicionarcolaborador" element={<AdicionarColaborador/>}/>     
     <Route exact path="/teste" element={<Uploader/>}/>     
     <Route exact path="/relatorio" element={<Relatorio/>}/>     
     <Route exact path="/ordens" element={<OrdensDeServico/>}/>     
     <Route exact path="/ordem" element={<Ordem/>}/>     
     <Route exact path="/login" element={<Entrar/>}/>     
     <Route exact path="/editarpendencia" element={<EditarPendencia/>}/>     
     <Route exact path="/menu" element={<Menu/>}/>  
     <Route exact path="/uploadMaster" element={<UploadMaster/>}/>  
     <Route exact path="/main" element={<Main/>}/>  
     <Route exact path="/editarprojeto" element={<EditarProjeto/>}/>  
     <Route exact path="/criarordem" element={<CriarOrdem/>}/>  
     <Route exact path="/participante" element={<Participante/>}/>  
     <Route exact path="/enviarmensagens" element={<EnviarMensagens/>}/>  
     <Route exact path="/editar" element={<Editar/>}/>  
     <Route exact path="/colaborador" element={<Colaborador/>}/>  
     <Route exact path="/msgenv" element={<CriarMensagem/>}/>  



      </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
